import Cookies from 'js-cookie';
import { ApiDomainUrl } from './Common';

export async function FetchData(url, method, token, body, options = {}) {
  if (sessionStorage.getItem('isImpersonation') === 'true' && !url.startsWith('/get')) {
    return null;
  }
  const headers = {
    Accept: 'application/json',
    Authorization: token,
  };
  const isFormDataBody = body instanceof FormData;

  if (!isFormDataBody && options.contentType !== false) {
    headers['Content-Type'] = 'application/json';
  }

  const requestBody = isFormDataBody ? body : JSON.stringify(body);

  const response = await fetch(ApiDomainUrl() + url, {
    method: method,
    headers,
    body: requestBody,
  });

  // Some endpoints return an empty body; guard JSON parsing to avoid runtime errors.
  const raw = await response.text();
  let data = null;
  if (raw) {
    try {
      data = JSON.parse(raw);
    } catch (err) {
      // If the payload isn't JSON (e.g., plain text error), surface the text.
      data = raw;
    }
  }

  if (data === 'Unauthorized') {
    // alert('Your session is expired. You need to re-login.');
    Cookies.remove('user');
    window.location.reload();
  } else if (options.includeMeta === true) {
    return {
      data: data,
      ok: response.ok,
      status: response.status,
      contentType: (response.headers.get('content-type') || '').toLowerCase(),
      headers: response.headers,
    };
  } else {
    return data;
  }
}

export async function FetchFile(url, method, token, body, options = {}) {
  const response = await fetch(ApiDomainUrl() + url, {
    method: method,
    headers: {
      Accept: 'application/pdf',
      'Content-Type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(body),
  });

  if (options.includeMeta === true) {
    const blob = response.ok ? await response.blob() : null;
    return {
      blob,
      ok: response.ok,
      status: response.status,
      contentType: (response.headers.get('content-type') || '').toLowerCase(),
      headers: response.headers,
    };
  }

  if (!response.ok) {
    return null;
  }

  return await response.blob();
}

export async function UploadFile(url, token, body) {
  const response = await fetch(ApiDomainUrl() + url, {
    method: 'POST',
    enctype: 'multipart/form-data',
    headers: {
      Authorization: token,
    },
    body: body,
  });
  const data = await response.text();

  if (data === 'Unauthorized') {
    // alert('Your session is expired. You need to re-login.');
    Cookies.remove('user');
    window.location.reload();
  } else {
    return data;
  }
}

export async function FetchPiggyBack(url, method, token, body) {
  const response = await fetch(ApiDomainUrl() + url, {
    method: method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(body),
  });
  const data = await response.text();

  if (data === 'Unauthorized') {
    // alert('Your session is expired. You need to re-login.');
    Cookies.remove('user');
    window.location.reload();
  } else {
    return data;
  }
}
